import {h, Fragment} from "preact"
import Products from "./Products"
import Toolbar from "./Toolbar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import { wrapContent } from "./ContentWrapper"
import { InfiniteScroll } from "@nosto/preact"
import Loader from "./elements/Loader"
import ProductSkeletonGrid from './ProductSkeletonGrid'

import NoResults from "./NoResults"
import { useState } from "preact/hooks"

export function SerpBody({ loading, foundProducts }) {
    // if (loading) return <Loader />
    return (
        foundProducts ? <>
            {/* <SelectedFilters /> */}
            <Toolbar />
            <Products />
            <BottomToolbar />
        </> : <NoResults />
    )
}

export function SerpBodyInfiniteScroll({ loading, foundProducts }) {

    const [gridView, setGridView] = useState({
        desktop: 'four-column',
        mobile: 'two-column'
    })

    const handleViewChange = (newView) => {
        setGridView(newView)
    }

    const getGridClassName = () => {
        const desktopClass = `collection-products--${gridView.desktop}-grid`
        const mobileClass = `collection-products--${gridView.mobile}-grid`
        
        return `${desktopClass} ${mobileClass}`
    }

    if (!foundProducts) return loading ? <ProductSkeletonGrid /> : <NoResults />
    return (
        <>
            {/* <SelectedFilters /> */}
            <Toolbar onViewChange={handleViewChange}/>
            <InfiniteScroll>
                <Products className={getGridClassName()} viewConfig={gridView}/>
            </InfiniteScroll>
        </>
    )
}

// replace with following line to enable infinite scroll
// export default wrapContent("search", SerpBodyInfiniteScroll)
export default wrapContent("search", SerpBodyInfiniteScroll)
